import * as ActionTypes from "../constants/ActionTypes";
import {putFormData} from "./FormData";
import {getCart} from "../selectors/SimpleSelectors";
import {delve} from "../util/util";

export const selectCartProperty = (key, value) => ({
    type: ActionTypes.SELECT_CART_PROPERTY,
    selected: value,
    key
})

let dispatchFormDataTimeout = false;

export const querySelectCartProperty = (key, value) => (dispatch, getState) => {

    const immediateUpdateProperties = ['billingPeriod'];

    dispatch(selectCartProperty(key, value))
    return new Promise((resolve) => {
        if (dispatchFormDataTimeout) {
            clearTimeout(dispatchFormDataTimeout);
        }
        dispatchFormDataTimeout = setTimeout(() => {
            dispatchFormDataTimeout = false;
            resolve();
        }, immediateUpdateProperties.includes(key) ? 0 : 1000);
    }).then(() => {
        return dispatch(putFormData())
    });
}


export const toggleCartCommission = () => (dispatch, getState) => {

    const cart = getCart(getState());
    const initialCommission = delve(getState(), "outsourcing.initialCommission");

    if (cart.commission) {
        dispatch(selectCartProperty("commission", ""));
        return dispatch(putFormData())
    } else if (initialCommission) {
        dispatch(selectCartProperty("commission", initialCommission));
        return dispatch(putFormData())
    }

}



/** WEBPACK FOOTER **
 ** ./src/actions/Properties.js
 **/